// extracted by mini-css-extract-plugin
export default {"imageCard":"SearchItem_imageCard__c+I2N","label":"SearchItem_label__xTeFz","icon":"SearchItem_icon__IIj-i"};